<template>
  <div class="page-container">
    <NavbarApp />

    <div v-if="article" class="article-page">
      <h1 class="article-detail-title">{{ article.title }}</h1>
      <h3 v-if="article.subtitle">{{ article.subtitle }}</h3>

      <div class="article-detail-meta">
       <!-- <div class="share-buttons">
          <button @click="shareOnFacebook" class="share-button facebook">
            <i class="fab fa-facebook-f"></i>
          </button>
          <button @click="shareOnLinkedIn" class="share-button linkedin">
            <i class="fab fa-linkedin-in"></i>
          </button>
          <button @click="shareOnWhatsApp" class="share-button whatsapp">
            <i class="fab fa-whatsapp"></i>
          </button>
        </div> -->

        <div class="author-date-container">
          <span v-if="article.author" class="article-author">
            <router-link
              v-if="article.authorID"
              :to="getAuthorRoute(article.authorID)"
              class="author-link"
            >
              Av. {{ article.author }}
            </router-link>
            <span v-else>{{ article.author }}</span>
          </span>
          <span class="article-detail-date">{{ formatDate(article.date) }}</span>
        </div>
      </div>

      <img
        v-if="article.image"
        :src="article.image"
        :alt="article.title"
        class="article-detail-image"
      />

      <div
        v-if="article.content"
        class="article-detail-content"
        v-html="article.content"
      ></div>

      <div v-if="article.footnotes" class="article-footnotes">
        <div class="footnotes-content" v-html="article.footnotes"></div>
      </div>

      <router-link to="/news" class="back-to-news">
        ← {{ $t('articleDetail.backToNews') }}
      </router-link>
    </div>

    <div v-else class="article-not-found">
      <h1>{{ $t('articleDetail.notFoundTitle') }}</h1>
      <p>{{ $t('articleDetail.notFoundMessage') }}</p>
      <router-link to="/news" class="back-to-news">
        {{ $t('articleDetail.backToNews') }}
      </router-link>
    </div>

    <Section4 />
  </div>
</template>
<script>
import NavbarApp from '../components/HomePage/navbar-law.vue'
import Section4 from '../components/HomePage/section-4.vue'
import { teamAssociated } from '../data/associated'
import { teamMembers } from '../data/team'
import articlesData from '../database/news.json'
// useRouter este utilizat, dar nu este esențial pentru funcționalitatea de bază aici,
// deși îl păstrăm pentru a nu strica alte logici.
import { useRouter } from 'vue-router' 

export default {
    name: 'ArticlePage',
    components: {
        NavbarApp,
        Section4,
    },
    data() {
        return {
            article: null,
            router: useRouter() 
        }
    },
    // Eliminăm 'formattedContent' dacă nu este folosit în template cu v-html
    // (V-html="article.content" îl face inutil)
    
    created() {
        this.loadArticle();
    },
    watch: {
        '$route.params.id': {
            handler: 'loadArticle',
            immediate: true
        }
    },
    methods: {
        loadArticle() {
            const articleId = this.$route.params.id
            this.article = articlesData.find(a => a.id === articleId) || null
        },
        
        // ... (Metodele getAuthorRoute și formatDate rămân neschimbate) ...

        formatDate(dateString) {
            const options = { year: 'numeric', month: 'long', day: 'numeric' };
            return new Date(dateString).toLocaleDateString(this.$i18n.locale, options); 
        },

        getAuthorRoute(authorId) {
            if (!authorId) return '#';
            // Logică de rutare păstrată
            try {
                if (Array.isArray(teamMembers)) {
                    const teamMember = teamMembers.find(m => m.id === authorId)
                    if (teamMember) {
                        return `/team/${authorId}`
                    }
                }
                if (Array.isArray(teamAssociated)) {
                    const associatedMember = teamAssociated.find(m => m.id === authorId)
                    if (associatedMember) {
                        return `/team/associate/${authorId}`
                    }
                }
                console.warn(`No team or associated member found for authorId: ${authorId}`)
                return '#'
            } catch (error) {
                console.error('Error in getAuthorRoute:', error)
                return '#'
            }
        },

        getArticleUrl(articleId) {
            const langPrefix = `/${this.$i18n.locale}`; 
            return `${window.location.origin}${langPrefix}/news/${articleId}`;
        },

        /**
         * Partajare pe Facebook: Se bazează pe meta tag-urile OG (imagine, titlu, descriere).
         * Parametrul 'quote' adaugă titlul ca text atașat.
         */
        shareOnFacebook() {
            if (!this.article) return

            const url = window.location.href
            const title = this.article.title
            
            const shareUrl = [
                'https://www.facebook.com/sharer/sharer.php?',
                `u=${encodeURIComponent(url)}`,
                // Adăugăm titlul ca quote pentru a fi vizibil deasupra previzualizării
                `quote=${encodeURIComponent(title)}`,
                `hashtag=%23ISLAW` 
            ].join('&');

            this.openShareWindow(shareUrl, 'FacebookShare')
        },

        /**
         * Partajare pe LinkedIn: Se bazează pe meta tag-urile OG pentru imagine și descriere.
         * Titlul și URL-ul sunt transmise direct.
         */
        shareOnLinkedIn() {
            if (!this.article) return

            const url = this.getArticleUrl(this.article.id);
            const title = encodeURIComponent(this.article.title);
            
            // Parametrul summary nu mai este folosit, ne bazăm pe OG desc.
            const shareUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(url)}&title=${title}`;
            
            this.openShareWindow(shareUrl, 'LinkedInShare');
        },

        /**
         * Partajare pe WhatsApp: Se bazează pe text și URL.
         * Previzualizarea linkului va folosi meta tag-urile OG.
         */
        shareOnWhatsApp() {
            if (!this.article) return

            const url = this.getArticleUrl(this.article.id);
            const title = this.article.title;
            
            // Adăugăm titlul ca parte a mesajului text.
            const message = `Vă invit să citiți: ${title}\n\n`; 
            const textMessage = `${message}${url}`;
            
            const shareUrl = `https://wa.me/?text=${encodeURIComponent(textMessage)}`;
            
            this.openShareWindow(shareUrl, 'WhatsAppShare');
        },

        openShareWindow(url, windowName) {
            const width = 626
            const height = 436
            const left = (window.innerWidth - width) / 2
            const top = (window.innerHeight - height) / 2
            window.open(
                url,
                windowName,
                `width=${width},height=${height},left=${left},top=${top},toolbar=0,menubar=0,location=0,status=0`
            )
        }
    },

    /**
     * 💡 Secțiunea CRITICĂ: Meta Tag-urile Open Graph (OG)
     */
    metaInfo() {
        if (!this.article) {
            return { title: 'Articol în curs de încărcare...' };
        }

        const article = this.article;
        const fullUrl = window.location.href; 
        // 1. Imaginea absolută
        const fullImageUrl = article.image ? window.location.origin + article.image : ''; 
        
        // 2. Descrierea: Preferă excerpt (care este mai complet) sau subtitle.
        const description = article.excerpt || article.subtitle || article.title; 
        
        // 3. Dimensiuni: Adăugăm dimensiuni explicite pentru OG:image (exemplu)
        const OG_IMAGE_WIDTH = '1200'; // Înlocuiește cu lățimea reală
        const OG_IMAGE_HEIGHT = '630'; // Înlocuiește cu înălțimea reală

        return {
            title: article.title, // Setează tag-ul <title>
            
            meta: [
                // Open Graph Tags
                { property: 'og:title', content: article.title },
                { property: 'og:description', content: description },
                { property: 'og:type', content: 'article' },
                { property: 'og:url', content: fullUrl },
                { property: 'og:image', content: fullImageUrl }, 
                
                // 🚨 Foarte important: Dimensiunile Explicite
                { property: 'og:image:width', content: OG_IMAGE_WIDTH },
                { property: 'og:image:height', content: OG_IMAGE_HEIGHT },

                // Twitter Card Tags
                { name: 'twitter:card', content: 'summary_large_image' },
                { name: 'twitter:title', content: article.title },
                { name: 'twitter:description', content: description },
                { name: 'twitter:image', content: fullImageUrl },
            ],
            link: [
                { rel: 'canonical', href: fullUrl }
            ]
        }
    }
};
</script>

<style scoped>
/* Secțiunea de stiluri (CSS) rămâne neschimbată */
/* ... */
</style>

<style scoped>
/* Include toate stilurile tale exact cum le-ai scris */
.article-footnotes { /* ... */ }
.article-detail-content { /* ... */ }
.article-detail-meta { /* ... */ }
/* Restul stilurilor rămân la fel */
</style>
<style scoped>
/* Stil pentru secțiunea de note de subsol */
.article-footnotes {
  margin-top: 50px;
  padding-top: 20px;
  border-top: 1px solid #ddd; /* Linia de separare */
}

.article-footnotes h3 {
  /* Titlul "Note de subsol:" */
  text-align: left;
  font-size: 1.2rem;
  font-weight: 700;
  color: #333;
  margin-bottom: 15px;
  margin-top: 0;
  padding-left: 20px;
}

/* Stil specific pentru lista de note */
.footnotes-content:deep(ol) {
    list-style-type: decimal;
    font-size: 0.9em;
    color: #666; 
    margin: 0;
    padding-left: 20px;
}

/* Stil pentru elementele individuale ale notei */
.footnotes-content:deep(li) {
    margin-bottom: 0.5em;
    line-height: 1.4;
    /* Alinierea justificată pentru textul notelor */
    text-align: justify; 
}

.article-detail-content:deep(a) {
  color: #bbd55a;
  text-decoration: none;
  font-weight: 500;
  border-bottom: 1px solid transparent;
  transition: all 0.2s ease;
  padding-bottom: 1px;
}

.article-detail-content:deep(a:hover) {
  color: #a4bf4c;
  border-bottom-color: #a4bf4c;
}

.article-detail-content:deep(a:visited) {
  color: #9ab348;
}

.article-detail-content:deep(a:active) {
  color: #8ca243;
}

.article-detail-content:deep(a:focus) {
  outline: 2px solid #bbd55a;
  outline-offset: 2px;
}

.article-detail-content:deep(a[target="_blank"]) {
  padding-right: 20px;
  position: relative;
}

.article-detail-content:deep(a[target="_blank"])::after {
  content: "↗";
  position: absolute;
  right: 0;
  top: 0;
  font-size: 0.8em;
  opacity: 0.7;
}
.article-detail-meta {
  display: flex;
  align-items: center;
  justify-content: space-between; 
  margin-bottom: 30px;
  padding: 0 20px;
}

.author-date-container {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 5px;
}

.article-detail-date,
.article-author {
  text-align: right;
  color: #777;
  font-size: 1rem;
}

.share-buttons {
  display: flex;
  gap: 10px;
}

.author-link {
  color: #bbd55a;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s ease;
}

.author-link:hover {
  color: #a4bf4c;
  text-decoration: underline;
}
/* Your existing styles are largely good for this component and will remain */
/* as they are. Just ensuring they are included here for completeness */
.article-page {
  padding: 40px 20px;
  max-width: 800px;
  margin: 0 auto;

  color: #333;
  line-height: 1.8;
}



.article-page h3 {
  color: #555;
  margin-top: -10px;
  margin-bottom: 20px;
  font-weight: 300;
  font-size: 1.5rem;
  line-height: 1.4;
  text-align: center ;
}

.article-not-found {
  text-align: center;
  padding: 100px 20px; 

  color: #555;
  height: 50vh; 
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.article-not-found h1 {
  color: #e74c3c; 
  margin-bottom: 20px;
  font-size: 2.5rem;
}

.article-not-found p {
  font-size: 1.2rem;
  margin-bottom: 30px;
}

.article-detail-title {
  font-size: 2.8rem;
  color: #333;
  text-align: center;
  margin-bottom: 20px;
  line-height: 1.2;
}

.article-detail-meta {
  text-align: center;
  font-size: 1rem;
  color: #777;
  margin-bottom: 30px;
}


.article-detail-image {
  width: 100%;
  max-height: 400px;
  object-fit: cover;
  border-radius: 8px;
  margin-bottom: 30px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
}

.article-detail-content {
  font-size: 1.1rem;
  color: #444;
  margin-bottom: 40px;
}

/* Basic styling for content rendered with v-html */
.article-detail-content:deep( p) {
  margin-bottom: 1em;
  /* Această linie era deja prezentă */
  text-align: justify; 
}

.article-detail-content:deep( h1),
.article-detail-content:deep( h2),
.article-detail-content:deep( h3),
.article-detail-content:deep( h4),
.article-detail-content:deep( h5),
.article-detail-content:deep( h6){
  margin-top: 2em;
  margin-bottom: 1em;
  color: #333;
  font-weight: 700;
  line-height: 1.3;
}

.article-detail-content:deep( h1) { font-size: 2.2rem; }
.article-detail-content:deep( h2) { font-size: 1.8rem; }
.article-detail-content:deep( h3) { font-size: 1.6rem; }
.article-detail-content:deep( h4) { font-size: 1.4rem; }
.article-detail-content:deep( h5) { font-size: 1.2rem; }
.article-detail-content:deep( h6){ font-size: 1rem; }

.article-detail-content:deep( ul),
.article-detail-content:deep( ol) {
  margin-bottom: 1em;
  padding-left: 25px;
  list-style-type: lower-alpha; 
}

.article-detail-content:deep(li > ul) {
  list-style-type: lower-roman;
}

.article-detail-content:deep(li > ul li > ul) {
  list-style-type: disc;
}

.article-detail-content:deep( li) {
  margin-bottom: 0.5em;
  /* NOU: Se aplică alinierea justificată și elementelor de listă */
  text-align: justify; 
}

.article-detail-content:deep( strong) {
  font-weight: 700;
}

.article-detail-content:deep( em ){
  font-style: italic;
}

/* Styling for the superscript references like [1] */
.article-detail-content:deep( sup) {
  font-size: 0.7em;
  vertical-align: super;
  line-height: 0;
}

.back-to-news {
  display: inline-block;
  margin-top: 20px;
  padding: 10px 20px;
  background-color: #bbd55a;
  color: white;
  text-decoration: none;
  border-radius: 5px;
  transition: background-color 0.3s ease, transform 0.2s ease;
  font-weight: 600;
}

.back-to-news:hover {
  background-color: #a4bf4c;
  transform: translateY(-2px);
}

/* Share buttons styles */

.share-button {
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: transform 0.2s ease, background-color 0.2s ease;
  color: white;
}

.share-button:hover {
  transform: scale(1.1);
}

.share-button.facebook {
  background-color: #1877f2;
}

.share-button.facebook:hover {
  background-color: #0d6ae4;
}

.share-button.linkedin {
  background-color: #0077b5;
}

.share-button.linkedin:hover {
  background-color: #006399;
}

.share-button.whatsapp {
  background-color: #25D366;
}

.share-button.whatsapp:hover {
  background-color: #20bd5a;
}

/* Make sure Font Awesome icons are properly sized */
.share-button i {
  font-size: 1rem;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .article-page {
    padding: 30px 15px;
  }

  .article-detail-title {
    font-size: 2.2rem;
  }

  .article-detail-content {
    font-size: 1rem;
  }

  .article-detail-image {
    max-height: 300px;
  }
}
  .article-detail-meta {
    flex-direction: column-reverse;
    align-items: center;
    gap: 15px;
  }

  .author-date-container {
    width: 100%;
  }

  .share-buttons {
    width: 100%;
    justify-content: center;
  }


@media (max-width: 480px) {
  .article-page {
    padding: 20px 10px;
  }

  .article-detail-title {
    font-size: 1.8rem;
  }

  .article-detail-meta {
    font-size: 0.9rem;
  }

  .article-detail-image {
    max-height: 200px;
  }

  .share-buttons {
    margin-top: 10px;
  }

  .share-button {
    width: 32px;
    height: 32px;
  }

  .share-button i {
    font-size: 0.9rem;
  }
}
</style>